(function () {
  'use strict';

  var LOGOS_PER_SLIDE = 6;
  var BATCH_SIZE = 36;
  // Upper bound on marquee duplicates, so a wall with two logos on an ultra-wide
  // screen cannot clone itself into thousands of nodes.
  var MAX_COPIES = 12;

  function createLogoElement(logo) {
    var item = document.createElement('div');
    item.className = 'logo-item';

    var logoDiv = document.createElement('div');
    logoDiv.className = 'logo-list__logo w-full text-center';
    item.appendChild(logoDiv);

    if (!logo.hasImage || !logo.imageUrl) return item;

    var img = document.createElement('img');
    img.src = logo.imageUrl;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = logo.imageWidth;
    img.height = logo.imageHeight;
    img.alt = logo.imageAlt || '';
    img.className = 'logo-list__logo-image w-auto';

    var contentWrapper = logoDiv;

    if (logo.link) {
      var a = document.createElement('a');
      a.href = logo.link;
      a.className = 'logo-list__logo-link block';
      logoDiv.appendChild(a);
      contentWrapper = a;
    }

    contentWrapper.appendChild(img);

    if (logo.text) {
      var p = document.createElement('p');
      p.className = 'pt-4 pb-0';
      p.textContent = logo.text;
      contentWrapper.appendChild(p);
    }

    return item;
  }

  function createSlide(logos) {
    var li = document.createElement('li');
    li.className = 'logo-carousel-column slider__item';
    for (var i = 0; i < logos.length; i++) {
      li.appendChild(createLogoElement(logos[i]));
    }
    return li;
  }

  function initLogoList(section) {
    var dataEl = section.querySelector('script[type="application/json"][id^="logo-list-data-"]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!data.length) return;

    var grid = section.querySelector('.logo-list');
    var slider = section.querySelector('.slider');
    if (!grid || !slider) return;

    var offset = 0;

    function renderBatch() {
      var batch = data.slice(offset, offset + BATCH_SIZE);
      if (!batch.length) return false;
      offset += batch.length;

      // Dynamically read the setting you chose in the Theme Editor sidebar
      var dynamicLogosPerSlide = parseInt(section.getAttribute('data-user-rows'), 10) || LOGOS_PER_SLIDE;

      for (var i = 0; i < batch.length; i += dynamicLogosPerSlide) {
        grid.appendChild(createSlide(batch.slice(i, i + dynamicLogosPerSlide)));
      }
      return offset < data.length;
    }

    // In theme editor render everything immediately so all logos are editable
    if (window.Shopify && window.Shopify.designMode) {
      while (offset < data.length) renderBatch();
      return;
    }

    function observeLastSlide() {
      var slides = grid.querySelectorAll('.logo-carousel-column');
      var lastSlide = slides[slides.length - 1];
      if (!lastSlide) return;

      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        var hasMore = renderBatch();
        if (hasMore) observeLastSlide();
      }, {
        root: slider,
        rootMargin: '0px 400px 0px 0px'
      });

      observer.observe(lastSlide);
    }

    observeLastSlide();
  }

  function rebuildCarouselColumns(sectionEl, rowCount) {
    var grid = sectionEl.querySelector('.logo-list.slider__grid');
    if (!grid) return;

    // Drop marquee clones so we only regroup real columns
    Array.from(grid.querySelectorAll('li.logo-carousel-column[data-logo-clone]')).forEach(function (col) {
      grid.removeChild(col);
    });

    var allItems = Array.from(grid.querySelectorAll('li.logo-carousel-column > .logo-item'));
    if (!allItems.length) return;

    // Remove all existing columns
    Array.from(grid.querySelectorAll('li.logo-carousel-column')).forEach(function (col) {
      grid.removeChild(col);
    });

    // Re-insert items grouped into columns of rowCount each
    for (var i = 0; i < allItems.length; i += rowCount) {
      var li = document.createElement('li');
      li.className = 'logo-carousel-column slider__item';
      for (var j = i; j < Math.min(i + rowCount, allItems.length); j++) {
        li.appendChild(allItems[j]);
      }
      grid.appendChild(li);
    }

    // Ask the carousel to recalculate scroll position and slide count
    var carouselEl = sectionEl.querySelector('carousel-slider');
    if (carouselEl) {
      if (typeof carouselEl.init === 'function') carouselEl.init();
      carouselEl.dispatchEvent(new CustomEvent('slider:reload', { bubbles: false }));
    }
  }

  function initControls(sectionEl) {
    // Attach directly to the controls div — it lives outside the carousel slider
    // so carousel drag handlers cannot intercept these clicks.
    var controlsEl = sectionEl.querySelector('.logo-list-controls');
    if (!controlsEl) return;

    controlsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-logo-ctrl]');
      if (!btn) return;

      e.stopPropagation(); // prevent any parent handlers from seeing this click

      var ctrl = btn.getAttribute('data-logo-ctrl');
      var targetId = btn.getAttribute('data-target-section');
      var target = document.getElementById('section-' + targetId);
      if (!target) return;

      if (ctrl === 'set-rows') {
        var rows = parseInt(btn.getAttribute('data-rows'), 10);
        target.setAttribute('data-user-rows', String(rows));

        // For carousel layout: rebuild the column groupings in the DOM
        rebuildCarouselColumns(sectionEl, rows);

        // Update active state on all row buttons
        controlsEl.querySelectorAll('[data-logo-ctrl="set-rows"]').forEach(function (rb) {
          rb.classList.toggle('is-active', parseInt(rb.getAttribute('data-rows'), 10) === rows);
        });
      }
    });
  }


  function initUserToggles(sectionEl) {
    // Find the button inside this specific section
    var toggleBtn = sectionEl.querySelector('[id^="user-toggle-names-"]');
    // Find the main section wrapper targeting the text elements
    var targetWrapper = sectionEl.querySelector('.section');

    if (!toggleBtn || !targetWrapper) return;

    toggleBtn.addEventListener('click', function (e) {
      e.stopPropagation();

      // Toggle the hiding class on the parent wrapper
      var namesAreHidden = targetWrapper.classList.toggle('user-hide-names');

      // Sync button text and visual weight
      if (namesAreHidden) {
        toggleBtn.textContent = 'Show Names';
        toggleBtn.classList.remove('is-active');
      } else {
        toggleBtn.textContent = 'Hide Names';
        toggleBtn.classList.add('is-active');
      }

      // Optional: Recalculate slider alignment if needed
      var carouselEl = sectionEl.querySelector('carousel-slider');
      if (carouselEl && typeof carouselEl.init === 'function') {
        carouselEl.dispatchEvent(new CustomEvent('slider:reload', { bubbles: false }));
      }
    });
  }

  function initAutoPlay(sectionEl) {
    var slider = sectionEl.querySelector('.slider');
    var grid = sectionEl.querySelector('.logo-list.slider__grid');
    if (!slider || !grid) return;

    var SPEED = 0.65; // px per frame @60fps — steady continuous glide
    var isHoverPaused = false;
    var isTouchPaused = false;
    var isDragging = false;
    var isInView = false;
    var wrapping = false;
    var finePointer = window.matchMedia('(pointer: fine)');
    var rafId = 0;
    var loopWidth = 0;
    var touchResumeTimer = null;

    // Avoid CSS smooth-scroll fighting the wrap jump
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';

    function isDesktop() {
      return finePointer.matches;
    }

    function realColumns() {
      return Array.from(grid.children).filter(function (el) {
        return el.classList && el.classList.contains('logo-carousel-column') && !el.hasAttribute('data-logo-clone');
      });
    }

    function reveal(el) {
      el.classList.add('cc-animate-in');
      el.removeAttribute('data-cc-animate');
      el.removeAttribute('data-cc-animate-delay');
      el.querySelectorAll('[data-cc-animate]').forEach(function (child) {
        child.classList.add('cc-animate-in');
        child.removeAttribute('data-cc-animate');
        child.removeAttribute('data-cc-animate-delay');
      });
    }

    function appendCopy(originals) {
      originals.forEach(function (col) {
        var clone = col.cloneNode(true);
        clone.setAttribute('data-logo-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        reveal(clone);
        clone.querySelectorAll('a').forEach(function (a) {
          a.setAttribute('tabindex', '-1');
        });
        grid.appendChild(clone);
      });
    }

    function setWidthOf(originals) {
      var first = originals[0];
      var last = originals[originals.length - 1];
      if (!first || !last) return 0;
      return last.offsetLeft + last.offsetWidth - first.offsetLeft;
    }

    function measureLoop() {
      var firstClone = grid.querySelector('li.logo-carousel-column[data-logo-clone]');
      var firstReal = realColumns()[0];
      if (firstClone && firstReal) {
        loopWidth = Math.round(firstClone.offsetLeft - firstReal.offsetLeft);
        if (loopWidth > 1) return;
      }
      loopWidth = Math.round(setWidthOf(realColumns()));
    }

    function copyCount() {
      var reals = realColumns().length;
      if (!reals) return 0;
      return Math.max(0, Math.round(grid.querySelectorAll('li.logo-carousel-column').length / reals) - 1);
    }

    function ensureLoop() {
      var originals = realColumns();
      if (!originals.length) return;

      originals.forEach(reveal);

      var setWidth = setWidthOf(originals);
      var needed = 2;
      if (setWidth > 0) {
        needed = Math.min(
          MAX_COPIES,
          Math.max(2, Math.ceil((slider.clientWidth * 2 + setWidth) / setWidth))
        );
      }

      while (copyCount() < needed) appendCopy(originals);

      measureLoop();
      unlockNav();
      enableDrag();
    }

    function enableDrag() {
      var carousel = sectionEl.querySelector('carousel-slider');
      // Keep the theme carousel inactive so it does not steal drag / wrap,
      // but make the track feel grabbable.
      slider.classList.add('is-grabbable');
      slider.style.cursor = 'grab';
      if (carousel) {
        carousel.setAttribute('inactive', '');
      }
    }

    function unlockNav() {
      sectionEl.querySelectorAll('.slider-nav__btn').forEach(function (btn) {
        btn.disabled = false;
      });
    }

    function shouldRun() {
      if (!isInView || isDragging || loopWidth <= 0) return false;
      if (isDesktop() && isHoverPaused) return false;
      if (!isDesktop() && isTouchPaused) return false;
      return true;
    }

    function wrapScroll() {
      if (loopWidth <= 1 || wrapping) return;
      wrapping = true;
      slider.style.scrollBehavior = 'auto';

      if (slider.scrollLeft >= loopWidth) {
        slider.scrollLeft = slider.scrollLeft % loopWidth;
      }

      var max = slider.scrollWidth - slider.clientWidth;
      if (max > 1 && slider.scrollLeft >= max - 1) {
        slider.scrollLeft = 0;
      }

      wrapping = false;
      unlockNav();
    }

    function tick() {
      rafId = 0;
      if (!shouldRun()) return;

      slider.scrollLeft += SPEED;
      wrapScroll();
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (rafId || !shouldRun()) return;
      ensureLoop();
      if (!shouldRun()) return;
      rafId = requestAnimationFrame(tick);
    }

    function stop() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = 0;
      }
    }

    function sync() {
      if (shouldRun()) start();
      else stop();
    }

    // Desktop — pause on hover
    sectionEl.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      isHoverPaused = true;
      sync();
    });
    sectionEl.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      isHoverPaused = false;
      sync();
    });

    // Mobile — pause while interacting with the visible logo wall
    slider.addEventListener('touchstart', function () {
      clearTimeout(touchResumeTimer);
      isTouchPaused = true;
      sync();
    }, { passive: true });
    function releaseTouchPause() {
      clearTimeout(touchResumeTimer);
      touchResumeTimer = setTimeout(function () {
        isTouchPaused = false;
        sync();
      }, 1800);
    }
    slider.addEventListener('touchend', releaseTouchPause, { passive: true });
    slider.addEventListener('touchcancel', releaseTouchPause, { passive: true });

    // Pause during desktop drag
    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      isDragging = true;
      sync();
    });
    window.addEventListener('pointerup', function () {
      if (!isDragging) return;
      isDragging = false;
      wrapScroll();
      sync();
    });
    window.addEventListener('pointercancel', function () {
      if (!isDragging) return;
      isDragging = false;
      wrapScroll();
      sync();
    });

    slider.addEventListener('scroll', function () {
      if (isDragging) return;
      wrapScroll();
      unlockNav();
    }, { passive: true });

    // Theme carousel uses behavior:'smooth', which would keep animating past
    // the wrap point. Handle chevrons ourselves so the loop stays seamless.
    var nav = sectionEl.querySelector('.slider-nav');
    if (nav) {
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('.slider-nav__btn');
        if (!btn) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        ensureLoop();
        var col = grid.querySelector('.logo-carousel-column');
        var gap = parseFloat(window.getComputedStyle(grid).columnGap) || 0;
        var span = col ? col.offsetWidth + gap : Math.round(slider.clientWidth * 0.25);
        if (btn.name === 'prev') span = -span;
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft += span;
        wrapScroll();
        unlockNav();
      }, true);
    }

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        ensureLoop();
        wrapScroll();
        sync();
      }).observe(grid);
    }

    window.addEventListener('resize', function () {
      ensureLoop();
      wrapScroll();
      sync();
    });

    new IntersectionObserver(function (entries) {
      isInView = entries[0].isIntersecting;
      sync();
    }, { threshold: 0.1 }).observe(sectionEl);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      ensureLoop();
      return;
    }

    grid.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        ensureLoop();
        wrapScroll();
        sync();
      }, { once: true });
    });

    ensureLoop();
  }

  function init() {
    document.querySelectorAll('.cc-logo-wall').forEach(function (section) {
      initLogoList(section);
      initControls(section);
      initUserToggles(section);
      initAutoPlay(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();